import { getFieldOnMainLanguage } from '@app/utils/languages';
import { getTypeLabel } from '@app/utils/questionUtils';
import { Card, Chip, Typography } from '@mui/material';

import { CheckedBorder } from '@app/components/CheckedBorder';
import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface QuestionListItemProps {
  questionObj: GenericObject;
  isQuestionSelected(question: GenericObject): boolean;
  selectQuestion(question: GenericObject): void;
}

export const QuestionListItem = ({ selectQuestion, questionObj, isQuestionSelected }: QuestionListItemProps) => {
  const responses = getFieldOnMainLanguage(questionObj?.responses);

  return (
    <Card
      key={questionObj.id as number}
      onClick={() => selectQuestion(questionObj)}
      sx={{
        height: 95,
        cursor: 'pointer',
        marginBottom: 1,
        position: 'relative',
        border: isQuestionSelected(questionObj) ? '2px solid #B484FF' : '',
      }}>
      <div style={{ display: 'flex', height: '100%', padding: 6 }}>
        <div
          style={{
            width: '50%',
            marginRight: '1vw',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}>
          <div>
            <Typography sx={{ fontSize: 14 }} gutterBottom>
              {getFieldOnMainLanguage(questionObj?.question)}
            </Typography>
          </div>
          <div>
            <Typography sx={{ fontSize: 10, marginRight: '2vw' }} color="text.secondary" gutterBottom>
              {getTypeLabel(questionObj)}
            </Typography>
          </div>
          {isQuestionSelected(questionObj) && <CheckedBorder />}
        </div>
        <div style={{ width: '50%', marginRight: '1vw' }}>
          <Typography sx={{ fontSize: 14 }} gutterBottom>
            VALUES
          </Typography>
          <div>
            {responses &&
              responses
                .split(',')
                .map((item) => (
                  <Chip key={item} label={item} size="small" sx={{ marginRight: '5px', marginBottom: '5px' }} />
                ))}
          </div>
        </div>
      </div>
    </Card>
  );
};
